<template>
  <div class="main-content">
    <avue-form ref="form" :value="form" :option="formOption">
      <template slot="defaultAvatar">
        <FormImgUpload
          :url="form.defaultAvatar"
          @upload="upload"
          :limit="1"
          :maxSize="2"
          :accept="'.png,.jpg'"
          :multiple="true"
        />
         <div style="color: #c0c1c3">建议尺寸：60px*60px，图片格式：.png，.jpg</div>
      </template>
      <template slot="defaultDeviceImage">
        <FormImgUpload
          :url="form.defaultDeviceImage"
          @upload="uploadDefaultDeviceImage"
          :limit="1"
          :maxSize="2"
          :accept="'.png,.jpg'"
          :multiple="true"
        />
        <div style="color: #c0c1c3">建议尺寸：170px*170px，图片格式：.png，.jpg</div>
      </template>
      <template slot="defaultGatewayImage">
        <FormImgUpload
          :url="form.defaultGatewayImage"
          @upload="uploadDefaultGatewayImage"
          :limit="1"
          :maxSize="2"
          :accept="'.png,.jpg'"
          :multiple="true"
        />
        <div style="color: #c0c1c3">建议尺寸：50px*50px，图片格式：.png，.jpg</div>
      </template>
      <template slot="defaultGroupImage">
        <FormImgUpload
          :url="form.defaultGroupImage"
          @upload="uploadDefaultGroupImage"
          :limit="1"
          :maxSize="2"
          :accept="'.png,.jpg'"
          :multiple="true"
        />
        <div style="color: #c0c1c3">建议尺寸：50px*50px，图片格式：.png，.jpg</div>
      </template>
      <template slot="platformLogo">
        <FormImgUpload
          :url="form.platformLogo"
          @upload="uploadDefaultPlatformLogo"
          :limit="1"
          :maxSize="2"
          :accept="'.png,.jpg'"
          :multiple="true"
        />
        <div style="color: #c0c1c3">建议尺寸：150px*35px，图片格式：.png，.jpg</div>
        <!-- onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/)" -->
      </template>
      <template slot="platformPhone">
        <el-input
          v-model="form.platformPhone"
          maxlength="20"
          placeholder="请输入"
          style="width: 300px"
          onkeyup="this.value=this.value"
          @blur="salaryDianChange($event, 'platformPhone')"
          type="text"
          clearable
        />
        <!-- onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/)" -->
      </template>
      <template slot="menuForm">
        <!-- <el-button @click="handleClose">取消</el-button> -->
        <el-button type="primary" :loading="showLoading" @click="submit(form)"
          >确定</el-button
        >
      </template>
    </avue-form>
  </div>
</template>
  
  <script>
import FormImgUpload from "@/components/formComponents/formImgUpload";
import { basicUpdate, basicView } from "@/api/system/basic";
import { enterChineseEnglish } from "@/utils/formRules";
import { userinfo } from "@/api";
export default {
  name: "createThree",
  components: {
    FormImgUpload,
  },
  data() {
    return {
      form: {
        defaultAvatar: [],
        defaultDeviceImage: [],
        defaultGatewayImage: [],
        defaultGroupImage: [],
        platformLogo:[]
      },
      showLoading: false,
      formOption: {
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 150,
        column: [
          {
            label: "默认头像",
            prop: "defaultAvatar",
            type: "text",
            maxlength: 50,
            span: 24,
            rules: [
              {
                required: true,
                message: "请上传",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error("请上传"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          {
            label: "默认设备图",
            prop: "defaultDeviceImage",
            type: "text",
            maxlength: 50,
            span: 24,
            rules: [
              {
                required: true,
                message: "请上传",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error("请上传"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          {
            label: "默认网关图",
            prop: "defaultGatewayImage",
            type: "text",
            maxlength: 50,
            span: 24,
            rules: [
              {
                required: true,
                message: "请上传",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error("请上传"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          {
            label: "默认分组图",
            prop: "defaultGroupImage",
            type: "text",
            maxlength: 50,
            span: 24,
            rules: [
              {
                required: true,
                message: "请上传",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error("请上传"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          {
            label: "logo",
            prop: "platformLogo",
            type: "text",
            maxlength: 50,
            span: 24,
            rules: [
              {
                required: true,
                message: "请上传",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error("请上传"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },

          {
            label: "平台联系电话",
            prop: "platformPhone",
            type: "text",
            maxlength: 20,
            span: 24,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入平台联系电话",
                trigger: "blur",
              },
              ...enterChineseEnglish,
            ],
          },
        ],
      },
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    //初始化
    onLoad() {
      this.showLoading = true;
      basicView().then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.form = {
            ...res.data,
            defaultAvatar: [res.data.defaultAvatar],
            defaultDeviceImage: [res.data.defaultDeviceImage],
            defaultGatewayImage: [res.data.defaultGatewayImage],
            defaultGroupImage: [res.data.defaultGroupImage],
            platformLogo:[res.data.platformLogo]
          };
        }
      });
    },
    //图片上传
    upload(e) {
      if (Array.isArray(e)) {
        this.form.defaultAvatar = [...e];
      } else {
        this.form.defaultAvatar = [...this.form.defaultAvatar, e];
      }
    },
    //默认设备图
    uploadDefaultDeviceImage(e) {
      if (Array.isArray(e)) {
        this.form.defaultDeviceImage = [...e];
      } else {
        this.form.defaultDeviceImage = [...this.form.defaultDeviceImage, e];
      }
    },
    //默认网关图
    uploadDefaultGatewayImage(e) {
      if (Array.isArray(e)) {
        this.form.defaultGatewayImage = [...e];
      } else {
        this.form.defaultGatewayImage = [...this.form.defaultGatewayImage, e];
      }
    },
    //默认分组图
    uploadDefaultGroupImage(e) {
      if (Array.isArray(e)) {
        this.form.defaultGroupImage = [...e];
      } else {
        this.form.defaultGroupImage = [...this.form.defaultGroupImage, e];
      }
    },
    //默认logo
    uploadDefaultPlatformLogo(e) {
      if (Array.isArray(e)) {
        this.form.platformLogo = [...e];
      } else {
        this.form.platformLogo = [
          ...this.form.platformLogo,
          e,
        ];
      }
    },

    //手机号输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    async setForm(form) {
      this.form = form;
    },
    //富文本框变化替换值
    editoChange(e) {
      this.form.details = e;
    },
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          const res = {
            ...form,
            defaultAvatar: form.defaultAvatar[0],
            defaultDeviceImage: form.defaultDeviceImage[0],
            defaultGatewayImage: form.defaultGatewayImage[0],
            defaultGroupImage: form.defaultGroupImage[0],
            platformLogo:form.platformLogo[0]
          };
          this.showLoading = true;
          basicUpdate({ ...res })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("操作成功");
                this.dialogVisible = false;
                setTimeout(() => {
                  this.resetForm();
                }, 500);
                this.onLoad();
                this.getUserInfo()
                this.showLoading = false;
              } else {
                // this.$message.error(res.msg);
                this.showLoading = false;
                done();
              }
            })
            .catch(() =>{this.showLoading = false});
          // done()
        }
      });
    },
    getUserInfo(){
       userinfo()
      .then((res) => {
        if (res.code === 200) {
          this.headPortrait = res.data.headPortrait;
          this.fullName = res.data.fullName;
          this.$store.commit("setUserInfo", res.data);
        }
      })
      .catch((err) => {
        // this.$message.error(err.msg)
      });
    }
  },
};
</script>
  
  <style scoped>
</style>